export enum LegacyExamQuestionAnalyticsType {
  Analytics = 'analytics',
  Calculation = 'calculationAnalytics',
  Proof = 'proofAnalytics',
  ShortAnswer = 'shortAnswerAnalytics',
  ExtendedResponse = 'extendedResponseAnalytics',
  MultipleChoice = 'multipleChoiceAnalytics',
  Graphing = 'graphingAnalytics',
}
